import { combatStatsOf, effectiveDps } from './affixes.js';
import { equipmentBonus, wornPieces } from './inventory.js';
import { statsFor } from './stats.js';
/**
 * The ladder (ADR 0082): every character ranked by experience, and by the
 * damage per second its sheet shows. Fifty lines a board, then your own.
 */
export const LADDER_SIZE = 50;
/**
 * The DPS a character is ranked by: the sheet's, crits included
 * (`effectiveDps`), so the ladder says what the profile says.
 */
export function ladderDps(definition, level, equipped, templateOf) {
    const worn = wornPieces(equipped, templateOf);
    const stats = statsFor(definition, level, equipmentBonus(worn));
    return effectiveDps(stats.dps, combatStatsOf(worn.map((piece) => piece.affixes)));
}
/** Stored in tenths, like the sheet counts it (ADR 0015): an integer column sorts exactly. */
export function dpsTenths(dps) {
    return Math.round(dps * 10);
}
//# sourceMappingURL=ladder.js.map